var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Map needle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 13546",
    d: "M3.60368 10.0296C2.7198 10.4313 2.86931 11.7301 3.82137 11.9205L9.47381 13.051C10.2655 13.2094 10.8844 13.8282 11.0427 14.6199L12.1732 20.2724C12.3636 21.2244 13.6624 21.374 14.0642 20.4901L20.5743 6.16779C21.339 4.48543 19.6083 2.75474 17.926 3.51945L3.60368 10.0296Z",
    strokeWidth: 2
  }))));
}
export default SvgMapLocation;